// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-ejuP","tabsBox":"styles_tabsBox__Fp8_Y","createButton":"styles_createButton__2iqLx"};